enum HandlerPriority {
    LOW = 0,
    NORMAL = 1,
    HIGH = 2
}

export default HandlerPriority;